export function getSocial(informations) {
  const { instagram, facebook, youtube, twitter, linkedin } = informations;
  const social = {};

  if (facebook) {
    social.facebook = {
      title: "Facebook",
      link: facebook,
      icon: "fa-facebook-f",
      size: 20,
    };
  }

  if (instagram) {
    social.instagram = {
      title: "Instagram",
      link: instagram,
      icon: "fa-instagram",
      size: 20,
    };
  }

  if (youtube) {
    social.youtube = {
      title: "Youtube",
      link: youtube,
      icon: "fa-youtube",
      size: 20,
    };
  }

  if (twitter) {
    social.twitter = {
      title: "Twitter",
      link: twitter,
      icon: "fa-twitter",
      size: 20,
    };
  }

  if (linkedin) {
    social.linkedin = {
      title: "Linkedin",
      link: linkedin,
      icon: "fa-linkedin",
      size: 20,
    };
  }

  return social;
}
